<template>
  <div>
    <div class="drop-count" v-if="drops.length > 1">
      {{ showingDropIndex + 1 }} / {{ drops.length }}
    </div>
    <div
    :style="{ left: (30 - 300 * showingDropIndex) + 'px' }"
    class="drop-container">
      <div
        v-for="(drop, index) in drops"
        :style="{ opacity: (index === showingDropIndex) ? 1 : 0, left: (index * 300) + 'px' }"
        class="drop">
        <ximg
			class="pixelated"
			:src="getDropImage(drop)"
			:ariaLabel="drop.name + ' drop image'"
			role="img"
		/>
        <div class="text-center" style="position: absolute; top: 136px; width: 300px">
          <div class="drop-item-name">
            {{ drop.name }}
          </div>
          <div class="drop-item-description">
            {{ drop.description }}
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div v-if="showingDropIndex > 0" @click="showingDropIndex--" class="drop-arrow _left" />
    </transition>
    <transition name="fade">
      <div v-if="showingDropIndex < drops.length - 1" @click="showingDropIndex++" class="drop-arrow _right" />
    </transition>
  </div>
</template>

<script>
export default {
	props: ['drops'],
	data () {
		return {
			showingDropIndex: 0,
		};
	},
	mounted () {
		document.addEventListener('keydown', this.onKeyDown);
	},
	beforeDestroy () {
		document.removeEventListener('keydown', this.onKeyDown);
	},
	methods: {
		onKeyDown(ev) {
			if(ev.keyCode === 37 || ev.keyCode === 65) { // LEFT or A
				this.showingDropIndex--;
			}
			else if(ev.keyCode === 39 || ev.keyCode === 68) { // RIGHT or D
				this.showingDropIndex++;
			}
		},
		getDropImage (item) {
			switch (item.type) {
			case 'avatar_item':
				return '/api/avatar/preview/' + item.id;
			case 'supply_drop_item':
			default:
				return '/img/member/drops/' + item.iconName + '.gif';
			}
		},
	},
	watch: {
		showingDropIndex (showingDropIndex) {
			if (showingDropIndex < 0) {
				this.showingDropIndex = 0;
			}  else if (showingDropIndex >= this.drops.length) {
				this.showingDropIndex = Math.max(0, this.drops.length - 1);
			}
		},
	},
};
</script>
